export default __webpack_public_path__ + "static/Precise_Privacy_Policy-3f5521380089ddedd8b7d13d2726dae2.pdf";